import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        MenuVisivel: false,
        usuario: null,
    },
    mutations: {
        alternaMenu(state, visibilidade) {
            if(!state.usuario) {
                state.MenuVisivel = false
                return
            }
            if(visibilidade === undefined) {
                state.MenuVisivel = !state.MenuVisivel    //Alterna visibilidade do menu interativo
            } else {
                state.MenuVisivel = visibilidade
            }
        },
        setUser(state, usuario) {
            state.usuario = usuario
            if(usuario) {
                axios.defaults.headers.common['Authorization'] = `bearer ${usuario.token}`
                state.MenuVisivel = true
            } else {
                delete axios.defaults.headers.common['Authorization']
                state.MenuVisivel = false
            }
        },
    },
    //actions: {
        //fechaMenuAsync ({ commit }) {
            //setTimeout(function(){
                //commit('alternaMenu', false)
            //}, 1000);
        //}
    //}
})